import React, { useEffect, useRef, useState } from "react";
import Header from "./components/Header";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer/index";
import Main from "./Pages/Main/index";
import SP01Info from "./Pages/SP01-info";
import Shop from "./Pages/Shop";
import Listen from "./Pages/Listen";
import Info from "./Pages/Info";
import SoundAdvice from "./Pages/SoundAdvice";
import Formalities from "./Pages/Formalities";
import { useContext } from "react";
import { AppContext } from "./context/appContext";
import Cart from "./components/Cart";
import Menu from "./components/Menu";
import SP01 from "./Pages/Product";
import ScrollToTop from "./ScrollToTop";
import Product from "./Pages/Product";

import MP3Player from "./components/MP3Player";
import Mar from "./components/Marquee";

import { ShopContext } from "./context/shopContext";
import {
  fetchProductList,
  createCheckout,
  fetchCheckout,
} from "./utils/shopify";
import Popup from "./components/Popup";

function App() {
  const { isCartOpen, isMenuOpen } = useContext(AppContext);
  const { setProductList, setCheckout, productList } = useContext(ShopContext);
  const [isPopUp, setIspopup] = useState(false);

  useEffect(() => {
    // Check if checkoutId exists in localStorage and if not create a new checkout
    const _checkCheckoutId = async () => {
      const _checkoutId = localStorage.getItem("checkoutId");

      if (!_checkoutId || _checkoutId == "undefined") {
        const newCheckout = await createCheckout();
        localStorage.setItem("checkoutId", newCheckout.id);
        setCheckout(newCheckout);
      } else {
        const checkout = await fetchCheckout(_checkoutId);
        setCheckout(checkout);
      }
    };

    // Fetch product list from shopify
    const _fetchProductList = async () => {
      const newProductList = await fetchProductList();
      setProductList(newProductList);
    };

    _checkCheckoutId();
    _fetchProductList();

    setTimeout(() => {
      setIspopup(true);
    }, 100);
  }, []);

  return (
    <BrowserRouter>
      <Header />
      {isCartOpen && <Cart />}
      {isMenuOpen && <Menu />}
      {isPopUp && <Popup closeFunc={setIspopup} />}
      <ScrollToTop />

      <Routes>
        <Route
          path="/"
          element={<Main />}
        />

        <Route
          path="/:id"
          element={<Product />}
        />
        <Route
          path="/home"
          element={<Main />}
        />
        <Route
          path="/sp01-info"
          element={<SP01Info />}
        />
        <Route
          path="/shop"
          element={<Shop />}
        />
        <Route
          path="/listen"
          element={<Listen />}
        />
        <Route
          path="/info"
          element={<Info />}
        />
        <Route
          path="/sp01"
          element={<SP01 />}
        />

        <Route
          path="/soundadvice"
          element={<SoundAdvice />}
        />
        <Route
          path="/formalities"
          element={<Formalities />}
        />
      </Routes>
      <MP3Player />
      <Footer />
    </BrowserRouter>
  );
}

export default App;
